import { p as jsxRuntimeExports, B as DynamicMath } from "./doenetml-NmXDuMHr.js";
function renderLabelWithLatex({
  label,
  labelHasLatex
}) {
  if (labelHasLatex) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DynamicMath, { latex: label });
  }
  return label;
}
function accessibleLabelText({
  label,
  labelHasLatex,
  fallback
}) {
  const trimmed = label.trim();
  if (!trimmed) {
    return fallback;
  }
  return labelHasLatex ? fallback : trimmed;
}
export {
  accessibleLabelText as a,
  renderLabelWithLatex as r
};
